var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAxsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0055D5;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M440.6,0c243.3,0,440.6,197.3,440.6,440.6S683.9,881.2,440.6,881.2S0,683.9,0,440.6 S197.3,0,440.6,0L440.6,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    className: "st1",
    d: "M239.7,291.5c0,0-47.4-37.9-50.7,55.7c-3.3,72.5-3.2,213.3,30.4,279.9 c14.2,25,33.1,17.4,68.4-7.6c30.7-22.6,141.6-124.9,188.6-169.7s142.2-173.5,162.1-86.1c7.8,36.7,17.5,67.9,10.1,149.5 c-2.3,25.1-13,44.1-62,10.1c-37-23.8-72.2-49.3-72.2-49.3s-6.8-12.2-22.8,7.6c-12.6,15.8-18.9,19.7,1.2,31.6 c20.3,12,122.8,82.7,162.1,93.7c32.4,9.4,50.9,9.3,51.9-54.5c-0.2-50.6-3.1-195.4-21.5-257.1c-13.9-38.4-34.4-55.9-78.5-12.7 c-44.1,43.2-183.4,178.2-259.5,239.3c-50.5,37.9-72.1,72.1-91.1,8.9c-13.4-47.8-30.8-196.8,24.1-168.4 c34.3,16.4,51.4,16.3,38,26.6c-13.4,10.2-51.9,45.6-51.9,45.6s-11.9,9.6-6.3,30.4c5.6,14.5,5.6,21.8,35.4-6.3 s51.9-49.3,51.9-49.3s4.8-7.5,18.9,6.3c14.2,13.8,16.5,17.7,16.5,17.7s3.8,10.3,18.9-7.6c15.2-17.9,25-28.8-3.8-45.6 C369.1,363.3,239.7,291.5,239.7,291.5L239.7,291.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxsIcon);
export default __webpack_public_path__ + "static/media/axs_icon.c00af632bd02635fc816a6e177ae650e.svg";
export { ForwardRef as ReactComponent };